import React from 'react';
import { BrowserRouter as Router } from 'react-router-dom';
import { Provider } from 'react-redux';
import Routes from './Routes';
import Navbar from './components/Navbar';
import store from './store';

const App: React.FC = () => {
  console.log("api:",process.env.REACT_APP_API_URL);

  return (
    <Provider store={store}>
      <Router>
        <>
          <Navbar />
          <Routes />
        </>
      </Router>
    </Provider>
  );
};

export default App;
